var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnDestroy } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { FxAgGridValidationEditorComponent } from './fx-ag-grid-validation-editor';
var FxAgFormCellRendererComponent = /** @class */ (function (_super) {
    __extends(FxAgFormCellRendererComponent, _super);
    function FxAgFormCellRendererComponent(fb) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        _this.value = false;
        return _this;
        // console.warn('创建FormCellRenderer:');
    }
    FxAgFormCellRendererComponent.prototype.agInit = function (params) {
        this.params = params;
        this.value = this.params.getValue();
        this.formControl = new FormControl(this, params.validators);
        this.validateForm = params.form;
        if (!params.form) {
            this.validateForm = this.fb.group({});
        }
        this.name = this.params.node.id + '-' + params.column.colId;
        // console.warn('初始化FormCellRenderer:', this.name);
        if (this.validateForm.contains(this.name)) {
            this.validateForm.setControl(this.name, this.formControl);
        }
        else {
            this.validateForm.addControl(this.name, this.formControl);
        }
        this.formControl.markAsDirty();
        _super.prototype.init.call(this);
    };
    FxAgFormCellRendererComponent.prototype.refresh = function () {
        // console.warn('刷新FormCellRenderer:', this.name);
        return false;
    };
    FxAgFormCellRendererComponent.prototype.ngOnDestroy = function () {
        // console.warn('销毁FormCellRenderer:', this.name);
        this.validateForm.removeControl(this.name);
    };
    return FxAgFormCellRendererComponent;
}(FxAgGridValidationEditorComponent));
export { FxAgFormCellRendererComponent };
